export interface IRegionLanguage {
  code: string; // language code
  description: string;
  is_default: boolean; // true if the default consent language
  id?: number; // The consent ID for this language
}
/// used to select a language
